import React, {Component} from 'react';
import VideoPlayerSocialEmbedBox from './VideoPlayerSocialEmbedBox.jsx';

import Core from '../../Core/Core';

export class VideoPlayerSocialBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showEmbedBox: false
    }
  }

  socialHandler(event) {
    Core.utils.onSocialShare.bind(event.currentTarget)(event.nativeEvent);
  }

  toggleEmbedBox(event) {
    event.preventDefault();
    this.setState({
      showEmbedBox: !this.state.showEmbedBox
    });
  }

  hideEmbedBox(event) {
    event.preventDefault();
    this.setState({
      showEmbedBox: false
    });
  }

  render() {
    let {fb, tw, em, embed, baseUrl, title, content, tpMediaId} = this.props;
    let url = encodeURIComponent(baseUrl);
    let encodedTitle = encodeURIComponent(title);

    return (
      <div className="social-bar">
        <ul className="socials">
          <li className="social social-label">
            Share:
          </li>
          <li className="social">
            <a className="no-delay social-share"
               href={`https://www.facebook.com/sharer.php?p[url]=${url}&amp;p[title]=${encodedTitle}&amp;p[summary]=${content}`}
               data-social-service="facebook"
               data-social-url={baseUrl}
               data-social-name={title}
               data-social-description={content}
               data-ga-category={fb && fb.tracking && fb.tracking.category || 'social'}
               data-ga-action={fb && fb.tracking && fb.tracking.action || 'facebook/show'}
               data-ga-label={fb && fb.tracking && fb.tracking.label || baseUrl}
               onClick={this.socialHandler}>
              <i className="social-icon fab fa-facebook-f"></i>
            </a>
          </li>
          <li className="social">
            <a className="no-delay social-share"
               href={`https://twitter.com/intent/tweet?text=${encodedTitle}&url=${url}&via=TPT`}
               data-social-service="twitter"
               data-social-url={url}
               data-social-name={title}
               data-social-description={content}
               data-ga-category={tw && tw.tracking && tw.tracking.category || 'social'}
               data-ga-action={tw && tw.tracking && tw.tracking.action || 'twitter/show'}
               data-ga-label={tw && tw.tracking && tw.tracking.label || baseUrl}
               onClick={this.socialHandler}>
              <i className="social-icon fab fa-twitter"></i>
            </a>
          </li>
          <li className="social">
            <a className="no-delay social-share"
               href={`mailto:?subject=${encodedTitle}&body=${content} ${url}`}
               data-social-service="email"
               data-social-url={url}
               data-social-name={title}
               data-social-description={content}
               data-ga-category={em && em.tracking && em.tracking.category || 'social'}
               data-ga-action={em && em.tracking && em.tracking.action || 'facebook/show'}
               data-ga-label={em && em.tracking && em.tracking.label || baseUrl}
               onClick={this.socialHandler}>
              <i className="social-icon far fa-envelope"></i>
            </a>
          </li>

          {tpMediaId &&
            <li className="social">
              <a className="no-delay embed-toggle"
                 href="#embed-toggle"
                 onClick={this.toggleEmbedBox.bind(this)}>
                <i className="social-icon fas fa-code" aria-hidden="true"></i>
              </a>
            </li>
          }
        </ul>
        {this.state.showEmbedBox && tpMediaId &&
          <VideoPlayerSocialEmbedBox
            width={512}
            height={376}
            tpMediaId={tpMediaId}
            onClose={this.hideEmbedBox.bind(this)}
            gaAction={embed && embed.tracking && embed.tracking.action || 'embed/show'}
          />
        }
      </div>
    );
  }
}

export default VideoPlayerSocialBar;